import type { Dispatch, JSX, ReactNode, SetStateAction } from "react";

interface PanelTabProps {
  tabs: {
    id: string;
    label: string;
    icon?: ReactNode;
    disabled?: boolean;
  }[];
  setActiveTab: Dispatch<SetStateAction<string>>;
  activeTab: string;
}

export function PanelTabs({ tabs, setActiveTab, activeTab }: PanelTabProps) {
  return (
    <div className="flex gap-1 p-1 bg-slate-100 dark:bg-gray-800/60 rounded-xl mb-4">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        const isDisabled = tab.disabled;

        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => !isDisabled && setActiveTab(tab.id)}
            disabled={isDisabled}
            title={isDisabled ? `${tab.label} not available for this slide` : undefined}
            className={`
              flex-1 flex items-center justify-center gap-1.5 px-3 py-2 text-xs font-semibold rounded-lg
              transition-all duration-200 select-none
              ${
                isDisabled
                  ? "text-slate-300 dark:text-gray-600 cursor-not-allowed opacity-50"
                  : isActive
                    ? "bg-white dark:bg-gray-700 text-primary-600 dark:text-primary-400 shadow-sm ring-1 ring-slate-200/60 dark:ring-gray-600/40"
                    : "text-slate-500 dark:text-gray-400 hover:text-slate-700 dark:hover:text-gray-200 hover:bg-white/60 dark:hover:bg-gray-700/50"
              }
            `}
          >
            {tab.icon && (
              <span className={isActive ? "text-primary-500 dark:text-primary-400" : "opacity-70"}>
                {tab.icon}
              </span>
            )}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
